export const FETCH_INTRO_DATA_SUCCESS = "FETCH_INTRO_DATA_SUCCESS";
export const FETCH_INTRO_DATA_FAILURE = "FETCH_INTRO_DATA_FAILURE";
export const FETCH_SKILLS_DATA_SUCCESS = "FETCH_SKILLS_DATA_SUCCESS";
export const FETCH_SKILLS_DATA_FAILURE = "FETCH_SKILLS_DATA_FAILURE"